// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.6.0",
  date: "2026-08-18T07:48:28.435Z",
  gitInfo: {
    dirty: false,
    raw: "68fba2f6e",
    hash: "68fba2f6e",
    distance: null,
    tag: null,
    semver: null,
    suffix: "68fba2f6e",
    semverString: null
  }
};
/* tslint:enable */
